export const BUSINESS_INFO = {
  name: 'Henge London',
  url: 'https://london.henge07.com',
  image: 'https://london.henge07.com/images/og-image.jpg',
  telephone: '+442035149530',
  email: 'hengelondon@hengeuk.co.uk',
  address: {
    streetAddress: '254 Brompton Rd, South Kensington',
    addressLocality: 'London',
    addressRegion: 'Greater London',
    postalCode: 'SW3 2AS',
    addressCountry: 'GB'
  },
  geo: {
    latitude: 51.4941,
    longitude: -0.1691
  },
  openingHours: [
    {
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      opens: '10:00',
      closes: '18:00'
    }
  ],
  sameAs: [
    'https://www.instagram.com/henge07/',
    'https://www.facebook.com/henge07/',
    'https://www.youtube.com/user/Henge07Interiors/videos',
    'https://www.pinterest.it/henge07/_created/',
    'https://www.linkedin.com/company/henge07/'
  ]
}
